import React, { createContext, useState, useEffect } from 'react';
import { signInService } from 'services/auth';
import useLocalStorage from 'hooks/useLocalStorage';

const AuthContext = createContext({});


export const AuthProvider = ({ children }) => {

    const [storageUser, setStorageUser, removeStorageUser] = useLocalStorage('@authApp: user');
    const [username, setUsername, removeUsername] = useLocalStorage('@authApp: username');
    const [storageId, setStorageId, removeStorageId] = useLocalStorage('@authApp: id');
    const [storageIds, setStorageIds, removeStorageIds] = useLocalStorage('@authApp: ids');
    const [storageToken, setStorageToken, removeStorageToken] = useLocalStorage('@authApp: token');
    const [storageUserType, setStorageUserType, removeStorageUserType] = useLocalStorage('@authApp: userType');
    const [garlicType, setGarlicType, removeGarlicType] = useLocalStorage('@authApp: userGarlic');

    const [user, setUser] = useState({});
    const [loading, setLoading] = useState(true);
    const [garlic, setGarlic] = useState(false);
    useEffect(() => {
        setStorageUserAndToken();
        setLoading(false);
    }, []);

    useEffect(() => {
        setGarlicType(garlic);
    }, [garlic]);

    async function setStorageUserAndToken() {
        if (storageUser && storageToken) {
            const serialized = JSON.parse(storageUser);
            setUser(serialized);           
        }
    }

    const signIn = async (username, password) => {
        try {
            setLoading(true);
            const { data } = await signInService(username, password);
            setUser(data.user);
            setStorageIds(data.user.ids);
            const userSerialized = JSON.stringify(data.user);
            setStorageToken(data.token);
            setStorageUser(userSerialized);
            setStorageUserType(data.user.ids[1].type);
            setStorageId(data.user.ids[1].id);
            setLoading(false);
            setGarlicType(garlic);
        } catch (error) {
            console.log(error)
            setLoading(false);
        }
    }

    const signOut = () => {
        //api.defaults.headers.Authorization = undefined;
        setLoading(true);
        removeStorageUser();
        removeStorageToken();
        removeStorageUserType();
        removeStorageId();
        removeGarlicType();
        removeStorageIds();
        setGarlic(false);
        setUser({});
        setLoading(false);
    }
    const alterGarlic = () => {
        setGarlic(!garlic);
    }

    return (

        <AuthContext.Provider value={{
            signed: (user && user.username) ? true : false,
            user,
            signIn,
            signOut,
            alterGarlic,
            storageUserType,
            storageId,
            garlicType,
            loading,
            storageIds,
            setStorageId,
            storageUserType,
            setStorageUserType
        }}>
            {children}
        </AuthContext.Provider>
    )
}


export default AuthContext;